export var TypeEnvType;
(function (TypeEnvType) {
  TypeEnvType["LIVE"] = "live";
  TypeEnvType["CANARY"] = "canary";
  TypeEnvType["DEV"] = "dev";
})(TypeEnvType || (TypeEnvType = {}));